import type { IRange } from "monaco-editor";
import { resolveEnvironmentFileIdByPath } from "@/lib/environment-files";
import { useChatStore } from "@/stores/useChatStore";
import { useToastStore } from "@/stores/useToastStore";

/**
 * Problems パネルで選択した診断箇所をファイルエディタで表示する。
 * openFileAtRange (ストアの pendingReveals) 経由にすることで、対象ファイルが既にアクティブな
 * タブでも FileEditor 側の副作用が確実に発火し、その場でスクロールされる。
 */
export async function navigateToProblem(path: string, range: IRange): Promise<void> {
	let fileId: string | null;
	try {
		fileId = await resolveEnvironmentFileIdByPath(path);
	} catch (err) {
		useToastStore.getState().show({ type: "error", message: "対象のファイルを開けませんでした。" });
		throw err;
	}
	if (fileId === null) {
		useToastStore
			.getState()
			.show({ type: "error", message: "対象のファイルが見つかりませんでした。" });
		return;
	}
	useChatStore.getState().openFileAtRange(fileId, range);
}
